<app-navigazione-container [entrypoints]="entrypoints" (onFormRequestSubmit)="onFormRequestSubmit($event)">

</app-navigazione-container>
<app-submission-confirm [showPanel]="showSubmissionConfirm" (onStay)="showSubmissionConfirm=false">
</app-submission-confirm>